<template>
  
  <div class="group" :ref="refs.productIdGroup">
    
    <div class="group-header">
      <div class="group-title">What type of wardrobe would you like to build?</div>
    </div>

    <!-- <Selector
      :key=builder.products.fieldName
      :field-name=builder.products.fieldName
      :display-type=builder.products.displayType
      :selected=builder.currentItem[builder.products.fieldName]
      options-source="productOptions"
      @select-option="selectProduct"
    ></Selector> -->

    <Plan-Selector
      :key=builder.products.fieldName
      :field-name=builder.products.fieldName
      :display-type=builder.products.displayType
      :options=builder.products.options
      :selected=builder.currentItem[builder.products.fieldName]
      options-source="productOptions"
      @select-option="selectProduct"
    ></Plan-Selector>
    
  </div>
  
  <div class="group" :ref="refs.productLayoutIdGroup" v-if="builder.walkInWardrobeLayoutOptions.length > 1">
    
    <div class="group-header">
      <div class="group-title">What type of space do you have?</div>
    </div>

    <Plan-Selector
      :key=builder.productLayouts.fieldName
      :field-name=builder.productLayouts.fieldName
      :display-type=builder.productLayouts.displayType
      :selected=builder.currentItem[builder.productLayouts.fieldName]
      options-source="walkInWardrobeLayoutOptions"
      @select-option="selectProductLayout"
    ></Plan-Selector>
    
  </div>
      
  <div class="wardrobenotice" v-if="isChangingLayout">
    <div class="wardrobenotice-inner">
      Changing your the type and layout may mean selections you have previously saved are overwritten.
    </div>
  </div>
  
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

let tempProductLayoutIds = ref([]);
let originalProductId = builder.currentItem.productId;
let originalProductLayoutId = builder.currentItem.productLayoutId;

onMounted(() => {
  
  // if a productId and productLayoutId are already saved for the item, save it temporarily so the user won't lose it if they switch
  if (builder.currentItem.productId && builder.currentItem.productLayoutId) {
    tempProductLayoutIds.value[builder.currentItem.productId] = builder.currentItem.productLayoutId;
  }
  // console.log(tempProductLayoutIds);
  
});

const isChangingLayout = computed(() => {
  if (builder.currentItem.validStep > 1 && (builder.currentItem.productLayoutId !== originalProductLayoutId || builder.currentItem.productId !== originalProductId) ) {
    return true
  }
  return null;
})

function selectProduct(prop, opt) {

  // update item prop
  builder.setCurrentItemProp(prop, opt['id']);
  
  // check if a valid product layout is already selected
  const results = builder.productLayoutOptions.filter(obj => {
    return obj.id === builder.currentItem.productLayoutId && obj.productId === builder.currentItem.productId;
  });
  
  // set default product layout to use if needed
  const defaultProductLayoutId = opt.defaultProductLayoutId ?? tempProductLayoutIds.value[builder.currentItem.productId];
  
  // apply new default product layout if a valid one isn't selected
  if (!results.length) builder.setCurrentItemProp('productLayoutId', defaultProductLayoutId);

  // one-click continue
  if (builder.currentItem.productId != 2) builder.saveCurrentItem(true); 
  
}

function selectProductLayout(prop, opt) {
  if (_.isObject(opt)) {
    
    // update item prop
    builder.setCurrentItemProp(prop, opt['id']);
    
    // save product layout id against a product id temporarily so user can switch back and forth easily
    tempProductLayoutIds.value[builder.currentItem.productId] = opt.id

    // one-click continue
    builder.saveCurrentItem(true); 
  
  }
}

// init refs
let refHandles = [
  'productIdGroup',
  'productLayoutIdGroup'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>